import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import InfiniteList from '../../components/InfiniteList';
import PinCard from './PinCard';

// noinspection JSCheckFunctionSignatures
const PinsList = ({
  bgGradient,
  borderTopRadius,
  columns,
  isFiltered,
  onRequestPins,
  stateKey,
  textInputStateKey,
}) => {
  const {
    error,
    isLoading,
    response: pinsSearchResponse,
  } = useSelector(s => s.pins[stateKey]);

  const {textInputField} = useSelector(s => s.ui[textInputStateKey]) || {};
  const {hasNextPage, page, pins = []} = pinsSearchResponse || {};

  const unsavedTempPin = useSelector(s => s.pins.pinUnsavedTemp);
  const isUnsavedPinOwned = unsavedTempPin.streetViewId && !!pins.find(p => p.isOwnedByUser);


  const dispatch = useDispatch();

  // TODO: replace with dedicated content load request
  const isPlaceIdsSearch = !!useSelector(s => s.pins.pinsListSearch.ids); // could be a cluster or single 3d place
  const isSinglePhotoPin = isPlaceIdsSearch && pins && pins.length === 1 && pins[0].photos && pins[0].photos.length > 0;

  return (
    <InfiniteList
      {...{
        bgGradient,
        borderTopRadius,
        columns,
        error,
        isFiltered,
        isLoading,
        hasNextPage,
        page,
        items: unsavedTempPin.streetViewId && !isUnsavedPinOwned ? [unsavedTempPin, ...pins] : pins,
      }}
      onFetchNextPage={() => dispatch(onRequestPins({
        isNew: !hasNextPage,
        searchString: textInputField
      }))}
      renderItem={(pin) => {

        return <PinCard
          key={pin._id}
          autoLoadPhotos={isSinglePhotoPin}
          pin={!pin._id ? { // handle s.pins.pinUnsavedTemp
            ...pin,
            label: '',
            isUnsavedPinOwned,
          } : pin}
        />;
      }}
    />
  );
};

export default PinsList;
